import React, { useEffect } from 'react';
import {
    Container,
    Box,
    Card,
    CardContent,
    Typography,
    Grid,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LockClockIcon from '@mui/icons-material/LockClock';
import { SIGNIN } from '../../../routes/paths';
import { useDispatch } from 'react-redux';
import { useAuthContext } from '../../../contexts/authContext';
import { typesRedux } from '../../../shared/types/typesRedux';
import {
    ActionsWrapper,
    IconCircle,
    IconWrapper,
    Paragraph,
    Title,
} from '../general/stylesComponents/stylesComponents';
import { Copyright } from '../general/copyright/copyright';
import { AuthMessages } from '../../../shared/messages/authMessages';
import ButtonGeneral from '../general/buttons/buttonGeneral';

const ExpirationToken = () => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { logout, modeTheme } = useAuthContext();
    const { TITLE, SUBTITLE, MESSAGE } = AuthMessages.expirationToken;

    useEffect(() => {
        dispatch({
            type: typesRedux.LOGOUT_LOGIN,
            payload: '',
        });
        logout();
    }, []);

    return (
        <>
            <Grid
                container
                component="main"
                sx={{ height: '94.5vh', minWidth: '320px' }}
            >
                <Grid item xs={12}>
                    <Box id="Sesión expiró">
                        <Container maxWidth="md">
                            <Box mt={8}>
                                <Card
                                    sx={{
                                        boxShadow: 5,
                                        borderRadius: 3,
                                    }}
                                >
                                    <CardContent>
                                        <IconWrapper>
                                            <IconCircle modeTheme={modeTheme}>
                                                <LockClockIcon
                                                    sx={{
                                                        fontSize: '6rem',
                                                        color: 'primary.contrastText',
                                                        marginLeft: '1rem',
                                                    }}
                                                />
                                            </IconCircle>
                                        </IconWrapper>
                                        <Title
                                            variant="h4"
                                            modeTheme={modeTheme}
                                        >
                                            {TITLE}
                                        </Title>
                                        <Paragraph modeTheme={modeTheme}>
                                            {SUBTITLE}
                                        </Paragraph>
                                        <Typography
                                            align="center"
                                            variant="subtitle2"
                                            sx={{
                                                color: 'primary.main',
                                            }}
                                        >
                                            {MESSAGE}
                                        </Typography>
                                        <ActionsWrapper>
                                            <ButtonGeneral
                                                onClick={() => navigate(SIGNIN)}
                                                title="Iniciar Sesión"
                                                sx={{
                                                    backgroundColor:
                                                        'primary.main',
                                                }}
                                            />
                                        </ActionsWrapper>
                                    </CardContent>
                                </Card>
                            </Box>
                        </Container>
                    </Box>
                </Grid>
            </Grid>
            <Copyright clasName="copyrigth_expiration_token" />
        </>
    );
};

export default ExpirationToken;
